// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1ycdu","info":"UpdateTermsInfo_info__15cBV"};